import { EFormTab } from './e-form-tab.model';

export class EFormDataObject {
    TemplateId: number;
    InstanceId: number;
    Name: string;
    VersionNumber: number;
    Tabs: EFormTab[] = [];
    LastUsedTabId: number;
    LastUsedPageId: number;
    LastUsedControlId: number;
}